import { gunmetal1000, gunmetal400 } from '../../themes/palettes/blaze';
import { black1000, black555 } from '../../themes/palettes/late-ocean';

export const inputStyle = {
  /* see .Input in styles.css */
  input: {
    color: process.env.KITT_THEME_NAME === 'late-ocean' ? black1000 : gunmetal1000,
    'font-size': '16px',
    'line-height': '35px',
    'font-weight': '700',
  },

  /* see .Input::placeholder in styles.css */
  '::placeholder': {
    color: process.env.KITT_THEME_NAME === 'late-ocean' ? black555 : gunmetal400,
    'font-weight': 100,
  },
};
